import { useLang } from "../lib/i18n";

export default function LangToggle() {
  var ctx = useLang();
  return (
    <button
      data-testid="lang-toggle"
      onClick={function() { ctx.setLang(ctx.lang === "it" ? "en" : "it"); }}
      className="flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-semibold bg-slate-100 hover:bg-slate-200 text-slate-600 transition-colors border border-slate-200"
    >
      {ctx.lang === "it" ? "IT" : "EN"}
      <span className="text-sm">{ctx.lang === "it" ? "\ud83c\uddee\ud83c\uddf9" : "\ud83c\uddec\ud83c\udde7"}</span>
    </button>
  );
}
